export default function () {

    $('.rate-slider').slick({
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        infinite: true,
        arrows: false,
        dots: false,
        speed: 3000,
        autoplay: true,
        responsive: [{
            breakpoint: 640,
            settings: {
                autoplay: true,
                autoplaySpeed: 0,
                speed: 3000,
                pauseOnHover: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1219,
            settings: {
                autoplay: true,
                autoplaySpeed: 0,
                speed: 3000,
                pauseOnHover: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }]
    });

    const rateSlider = $(".rate-girls__slider");
    rateSlider.on('init', function (event, slick) {

        console.log(slick)
        let cur = $(slick.$slides[slick.currentSlide]);

        let next = cur.next();
        let prev = cur.prev();

        let next2 = cur.next().next();
        let prev2 = cur.prev().prev();

        let next3 = cur.next().next().next();
        let prev3 = cur.prev().prev().prev();

        prev.addClass('rate-prev');
        next.addClass('rate-next');

        prev2.addClass('rate-prev2');
        next2.addClass('rate-next2');

        prev3.addClass('rate-prev3');
        next3.addClass('rate-next3');

    }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        if(currentSlide === 1){

            $('.rate-girls__dislike').on( "click", function() {
                $('.slick-current .rate-like__last').fadeIn(600)
            });
        }

        let cur = $(slick.$slides[nextSlide]);
        let slides = $(slick.$slides)

        slides
            .removeClass('rate-next')
            .removeClass('rate-prev')
            .removeClass('rate-next2')
            .removeClass('rate-prev2')
            .removeClass('rate-next3')
            .removeClass('rate-prev3')

        cur.next().next().next().addClass('rate-next3')
        cur.next().next().addClass('rate-next2')
        cur.next().addClass('rate-next')

        cur.prev().prev().prev().addClass('rate-prev3')
        cur.prev().prev().addClass('rate-prev2')
        cur.prev().addClass('rate-prev')
    })

    rateSlider.slick({
        speed: 700,
        mobileFirst: true,
        initialSlide: 9,
        variableWidth: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        draggable: false,
        swipe: false,
        touchMove: false,
        swipeToSlide: false,
        infinite: false,
        prevArrow: $('.btn-prev'),
    });

    $( ".rate-girls__like" ).on( "click", function() {
        $('.slick-current .rate-like__bg').fadeIn(600)
    });

    $( ".rate-like__back" ).on( "click", function() {
        $('.rate-like__bg').fadeOut(0)
    });

    const currentPathName = window.location.pathname;


    const asianArr=[
        {name:"Orchidromance",link:"https://orchidromance.com/land/sp/40171b46", className: 'site-orchidromance',},
        {name:"EasternHoneys",link:"https://easternhoneys.com/land/sp/d4734ed9", className: 'site-easternhoneys',},
        {name:"AsianMelodies",link:"https://asianmelodies.com/land/sp/20598710", className: 'site-Asianmelodies',},
        {name:"asianfeels",link:"https://asianfeels.com/land/sp/2f244ce1", className: 'site-AsianFeels',},
        {name:"loverwhirl",link:"https://loverwhirl.com/land/sp/214c733b", className: 'site-loverwhirl',},];

    const slavicArr=[
        {name:"Bravodate",link:"https://bravodate.com/land/sp/6ee4935b", className: 'site-bravodate',},
        {name:"JollyRomance",link:"https://jollyromance.com/land/sp/b435e6f4", className: 'site-Jollyromance',},
        {name:"AmourFactory",link:"https://amourfactory.com/land/sp/4e8f8766", className: 'site-amourfactory',},
        {name:"AmourFeel",link:"https://amourfeel.com/land/sp/263fb41c", className: 'site-Amourfeel',},
        {name:"Rondevo",link:"https://rondevo.com/land/sp/0fe765b5", className: 'site-rondevo',},
    ];
    const latinaArr=[
        {name:"La-date",link:"https://la-date.com/land/sp/1f43b0af", className: 'site-Ladate',},
        {name:"LoveFort",link:"https://lovefort.com/land/sp/7f3e0941", className: 'site-Lovefort',},
        {name:"LATINFEELS",link:"https://latinfeels.com/land/sp/a5fb0234", className: 'site-Latinfeels',},
        {name:"Funchatt",link:"https://funchatt.com/land/sp/b4b4d065", className: 'site-Funchatt',},
    ];
    function setProduct(namePages, arr) {
        const randomItem = arr[Math.floor(Math.random() * arr.length)];

        const pages = document.querySelector(`.rate-like__last--${namePages}`)
        const rateImg = pages.querySelector('.rate-like__logo')
        const rateLogo = pages.querySelector('.rate-like__text span')
        const rateLink = pages.querySelector('.rate-like__chat')

        rateImg.setAttribute('src', `img/${randomItem.name}.svg`)
        rateLogo.textContent = randomItem.name
        rateLink.setAttribute('href', `${randomItem.link}`)
        rateLink.classList.add(`${randomItem.className}`)
    }

    switch (currentPathName) {
        case '/asian-rate.html':
            setProduct('asian', asianArr)
            $('.rate-btn').css('pointer-events', 'none')
            break;

        case '/slavic-rate.html':
            setProduct('slavic', slavicArr)
            $('.rate-btn').css('pointer-events', 'none')
            break;

        case '/latina-rate.html':
            setProduct('latina', latinaArr)
            $('.rate-btn').css('pointer-events', 'none')
            break;
    }
}


